// extracted by mini-css-extract-plugin
export default {"Container":"loading_Container__oyuXh","ContainerHidden":"loading_ContainerHidden__7YOck","logoWrapper":"loading_logoWrapper__fCux1","loadingWrapper":"loading_loadingWrapper__mi9e9"};